export const rateSetNamesMapAccommo = {
  'Nightly': 'ie DBLNIGHTLY',
  'Nightly: Midweek': 'ie DBLMIDWEEK1NT',
  'Nightly: Weekend': 'ie DBLWKEND1NT',
  'Minimum Night Stay': 'ie DBLNEWYEARS',
  'Extended Stay': 'ie DBLEXT5NT',
  'Special Event': 'ie DBLFORMULA1',
  'Stay Pay': 'ie DBLSTAYPAY3-4',
  'Bed & Breakfast': '',
  'Bed & Breakfast: Midweek': '',
  'Bed & Breakfast: Weekend': '',
  'Package': 'ie DBLSPAPKG',
  'Group': 'ie DBLGROUP',
  'Indicative': '',
};

export const rateSetNamesMapNonAccommo = {
  'Private/Custom': 'ie PVTCRS2HR',
  'Depart/Entry: Morning': 'ie AMCRS2HR',
  'Depart/Entry: Afternoon': 'ie NOONCRS1HR',
  'Depart/Entry: Evening': 'ie EVECRS2HR',
  'Depart/Entry: Night': 'ie PMCRS2HR',
  'Special Event': 'ie NYECRUISE',
  'Foreign Language': 'ie SPANISH',
  'Indicative': '',
};

export const seasonColors = [
  '#d81b60',
  '#8e24aa',
  '#3949ab',
  '#00897b',
  '#00600f',
  '#f57f17',
  '#3e2723',
];

export const extraNameAndCode = {
  'Car Hire': 'ie WKENDHIRE',
  'Day Tour/Activity': 'ie BICYCLEHIRE',
  'Diving: Certified Dive': '',
  'Diving: Intro Dive': '',
  'Diving: Helmet Dive': '',
  'Diving: Equipment Hire': '',
  'Extra Night: Double': 'ie EXNIGHTDBL',
  'Extra Night: Quad': 'ie EXNIGHTQUAD',
  'Extra Night: Room': 'ie EXNIGHTDBL',
  'Extra Night: Single': 'ie EXNIGHTSGL',
  'Extra Night: Triple': 'ie EXNIGHTTRPL',
  'Extra Night: Twin': 'ie EXNIGHTTWIN',
  'Meal: Breakfast - A La Carte': '',
  'Meal: Breakfast - American': '',
  'Meal: Breakfast - Buffet': '',
  'Meal: Breakfast - Continental': '',
  'Meal: Breakfast - Full': '',
  'Meal: Breakfast': 'ie CONTINENTAL',
  'Meal: Lunch - A La Carte': '',
  'Meal: Lunch - Buffet': '',
  'Meal: Lunch - BBQ': '',
  'Meal: Lunch - Two Course': '',
  'Meal: Lunch - Three Course': '',
  'Meal: Lunch': 'ie PICNICLUNCH',
  'Meal: Dinner - A La Carte': '',
  'Meal: Dinner - Buffet': '',
  'Meal: Dinner - BBQ': '',
  'Meal: Dinner - Two Course': '',
  'Meal: Dinner - Three Course': '',
  'Meal: Dinner': 'ie ALACARTE',
  'Meal: Full Board': 'ie FULLBOARD',
  'Meal: Half Board': 'ie HALFBOARD',
  'Meal: Package': 'ie SUNDAYROAST',
  'Miscellaneous': 'ie WIFI',
  'Porterage: One Way': '',
  'Porterage: Return': '',
  'Surcharge: Additional Bedding': 'ie ROLLAWAY',
  'Surcharge: Baby Seat': '',
  'Surcharge: Entry': '',
  'Surcharge: Equipment Hire': '',
  'Surcharge: Extra Hour(s)': '',
  'Surcharge: Extra Pax': 'ie EXTRAADULT',
  'Surcharge: Family Rate': '',
  'Surcharge: Foreign Language': 'ie SPANISH',
  'Surcharge: Fuel': 'ie TANKREFILL',
  'Surcharge: General Sundry': 'ie BEACHGEAR',
  'Surcharge: Insurance': 'ie CANCELLATION',
  'Surcharge: Internet': 'ie INTERNET',
  'Surcharge: Park Fee': 'ie NTLPARKSFEE',
  'Surcharge: Parking': 'ie CARPARK',
  'Surcharge: Private Guide': '',
  'Surcharge: Refresh Service': 'ie DAILYSERVICE',
  'Surcharge: Tax': 'ie STATETAX',
  'Surcharge: Other': '',
  'Transfer: One Way': 'ie ONEWAY',
  'Transfer: Return': 'ie RETURN',
  'Transfer: Baby Seat': '',
  'Upgrade: Room': 'ie UPGRADE',
  'Upgrade: Package': 'ie SPAPACKAGE',
  'Upgrade: Person': '',
};

export const seasonNamesMap = {
  'All Year': [],
  'Standard': [],
  'Premium': [],
  'Peak/High Season': [],
  'Mid/Shoulder Season': [],
  'Off-Peak/Low Season': [],
  'Special Event': [],
  'Summer': [],
  'Winter': [],
  'Spring': [],
  'Fall/Autumn': [],
  'Christmas Holidays': [],
  'Easter Holidays': [],
  'New Years Holidays': [],
  'Chinese/Lunar New Years Holidays': [],
  'January': [],
  'February': [],
  'March': [],
  'April': [],
  'May': [],
  'June': [],
  'July': [],
  'August': [],
  'September': [],
  'October': [],
  'November': [],
  'December': [],
  '1st Quarter: January - March': [],
  '2nd Quarter: April - June': [],
  '3rd Quarter: July - September': [],
  '4th Quarter: October - December': [],
  'Not Operating': [],
  'Dynamic Rates': [],
};

export const standardNonAccomDescrs = [
  'Adult',
  'Child',
  'Infant',
  'Family',
  'Senior/Concession',
  'Student',
  'General',
];

export const multiDayTourDescrs = [
  'Single',
  'Twin (Share)',
  'Twin (Private)',
  'Double',
  'Triple',
  'Quad',
  'Single Supplement',
  'Extra Adult',
  'Extra Child',
  'Extra Child (Quad Share)',
  'Extra Infant',
];


export const standardAccomDescr = [
  'Single',
  'Twin',
  'Double',
  'Triple',
  'Quad',
  'Extra Adult',
  'Extra Child',
  'Extra Infant',
];
// multi day tour is per person rate
export const multiDayToursMaxAdultOne = [
  'Single',
  'Twin (Share)',
  'Twin (Private)',
  'Double',
  'Triple',
  'Quad',
  'Extra Adult',
];

export const multiDayToursMaxChildOne = [
  'Extra Child',
];

export const policyNotesSections = {
  submissionCriteria: 'Notes',
  termsAndConditions: 'Terms & Condition',
  marketInfo: 'Market Information',
  cancellation: 'Cancellation Policy',
  child: 'Child Policy',
  infant: 'Infant Policy',
  group: 'Group Policy',
  freeOfCharge: 'Free of Charge Policy',
  family: 'Family Policy',
  checkinout: 'Check-in and Check-out Policy',
  billingInfo: 'Billing Information',
  insuranceInfo: 'Insurance Information',
};



// WEBPACK FOOTER //
// ./src/app/utils/contracting-preset-names-codes.js